/// <amd-module name="Test/TestPlansHubRefresh/TestCaseWorkItemControls/TestSteps/TestStepsUtils/HtmlUtils" />

// Based on code in \Tfs\Service\WebAccess\TestManagement\Scripts\TFS.TestManagement.ts
import { HtmlSanitizer } from "roosterjs-react";

var _domParser: DOMParser = new DOMParser(); //TODO: Pass the parser in with ctor?

export class HtmlUtils {
    public static wrapInDiv(content: string): string {
        return "<div>" + content + "</div>";
    }

    public static encodeLeftAngularBracket(content: string): string {
        if (content) {
            content = content.replace(/\r?</g, "&lt;");
        }
        return content;
    }

    public static sanitizedText(content: string): string {
        return _domParser.parseFromString(HtmlUtils.wrapInDiv(HtmlSanitizer.sanitizeHtml(content)), "application/xml").textContent ?? "";
    }

    public static isEmptyText(content: string): boolean {
        let text = HtmlUtils.sanitizedText(content);
        return text.trim() === "";
    }

    public static replaceNewLineWithBr(paramString: string): string {
        if (!paramString || paramString.trim() === "") {
            return paramString;
        }

        paramString = paramString.replace(/\r?\n/g, "<br />");
        return paramString;
    }

    public static getPlainTextLines(htmlString: string): string[] {
        //Before getting the plain text from html preserve the new lines with \n, so that we can split on the base of \n after converting to plain text.
        if (htmlString !== undefined && htmlString !== null) {
            htmlString = HtmlSanitizer.sanitizeHtml(htmlString);
            htmlString = htmlString.replace(/<\/p><p>|<p>|<\/p>|<br>|<br\/>|<br \/>/gi, "\n");

            return _domParser.parseFromString(HtmlUtils.wrapInDiv(htmlString), "application/xml").textContent?.split("\n") ?? [];
        } else {
            return [];
        }
    }

    // TODO: This function seems to not be called. Delete it?
    // public static replaceEmptyParagraphTagsWithNbsp($lines: JQuery): JQuery {
    //     let length = $lines.length,
    //         index = 0,
    //         $line: JQuery;

    //     for (index = 0; index < length; index++) {
    //         $line = $($lines[index]);
    //         if ($line.text().trim() === "") {
    //             $line.html("&nbsp;");
    //         }
    //     }

    //     return $lines;
    // }
}
